import { ApiAccountsDetails } from '../types/accountsDetailsApi.types';
import { AccountDetails } from '../../transportAssignment/userDetails.types';

export const mapAccountsDetails = (apiAccountsDetails: ApiAccountsDetails): AccountDetails => {
    return { name: apiAccountsDetails.name, email: apiAccountsDetails.contacts.general.email };
};
